<div class="row">
  <!-- Country Grid -->
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-earth-americas"></i> Ülke Bilgileri</h2>
    <dx-data-grid
      [dataSource]="countries"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createCountry($event)"
      (onRowUpdating)="updateCountry($event)"
      (onRowRemoved)="deleteCountry($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil" class="delete-button"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Ülke Adı"></dxi-column>
      <dxi-column dataField="description" caption="Açıklama"></dxi-column>
    </dx-data-grid>
  </div>
  <!-- City Grid -->
<div class="col-md-6">
  <h2 class="content-block"><i class="fa-solid fa-city"></i> Şehirler</h2>
  <dx-data-grid
    [dataSource]="cities"
    class="content-block card responsive-paddings"
    keyExpr="id"
    (onRowInserting)="createCities($event)"
    (onRowUpdating)="updateCities($event)"
    (onRowRemoved)="deleteCities($event)"
  >
    <dxo-editing
      mode="row"
      [allowUpdating]="true"
      [allowDeleting]="true"
      [allowAdding]="true"
    ></dxo-editing>

    <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[5, 15, 25]"
      [showInfo]="true"
    ></dxo-pager>
    <dxo-export [enabled]="false"></dxo-export>

    <dxi-column type="buttons" width="110">
      <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
      <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
    </dxi-column>

    <!-- Şehir Adı -->
    <dxi-column dataField="name" caption="Şehir Adı">
      <dxi-validation-rule
        type="required"
        message="Şehir adı zorunludur"
      ></dxi-validation-rule>
    </dxi-column>
  </dx-data-grid>
</div>

</div>




<div class="row">
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-user-tie"></i> Meslek Bilgileri</h2>
    <dx-data-grid
      [dataSource]="professions"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createProfession($event)"
      (onRowUpdating)="updateProfession($event)"
      (onRowRemoved)="deleteProfession($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Ad">
        <dxi-validation-rule
          type="required"
          message="Meslek adı zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="description" caption="Açıklama">
        <dxi-validation-rule
          type="required"
          message="Açıklama zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <!-- VisaCountryId için Lookup Kullanımı -->
      <dxi-column dataField="visaCountryId" caption="Ülke">
        <dxo-lookup
          [dataSource]="countries"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="Ülke seçimi zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>

  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-list-check"></i> Vize Durumu</h2>
    <dx-data-grid
      [dataSource]="visaStatuses"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createVisaStatus($event)"
      (onRowUpdating)="updateVisaStatus($event)"
      (onRowRemoved)="deleteVisaStatus($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Adı">
        <dxi-validation-rule
          type="required"
          message="Vize Durumu adı zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="description" caption="Açıklama">
        <dxi-validation-rule
          type="required"
          message="Açıklama zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>

</div>

<div class="row">
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-graduation-cap"></i> Öğrenim Durumu</h2>
    <dx-data-grid
      [dataSource]="educations"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createEducation($event)"
      (onRowUpdating)="updateEducation($event)"
      (onRowRemoved)="deleteEducation($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Adı">
        <dxi-validation-rule
          type="required"
          message="Öğrenim Durumu adı zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="description" caption="Açıklama">
        <dxi-validation-rule
          type="required"
          message="Açıklama zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="visaCountryId" caption="Ülke">
        <dxo-lookup
          [dataSource]="countries"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="Ülke seçimi zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>

  <!-- Family Membership Grid -->
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-users"></i> Grup Üyeliği</h2>
    <dx-data-grid
      [dataSource]="familyMemberships"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createFamilyMembership($event)"
      (onRowUpdating)="updateFamilyMembership($event)"
      (onRowRemoved)="deleteFamilyMembership($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Ad">
        <dxi-validation-rule
          type="required"
          message="Üyelik adı zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="description" caption="Açıklama">
        <dxi-validation-rule
          type="required"
          message="Açıklama zorunludur"
        ></dxi-validation-rule>
      </dxi-column>

            <!-- VisaCountryId için Lookup Kullanımı -->
      <dxi-column dataField="visaCountryId" caption="Ülke">
        <dxo-lookup
          [dataSource]="countries"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="Ülke seçimi zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>


<div class="row">
  <!-- Religion Grid -->
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-kaaba"></i> İnanç Durumu</h2>
    <dx-data-grid
      [dataSource]="religions"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createReligion($event)"
      (onRowUpdating)="updateReligion($event)"
      (onRowRemoved)="deleteReligion($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Adı">
        <dxi-validation-rule
          type="required"
          message="İnanç Durumu adı zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="description" caption="Açıklama">
        <dxi-validation-rule
          type="required"
          message="Açıklama zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="visaCountryId" caption="Ülke">
        <dxo-lookup
          [dataSource]="countries"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="Ülke seçimi zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>
  <!-- Visa Language Grid -->
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-language"></i> Dil</h2>
    <dx-data-grid
      [dataSource]="visaLanguages"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createVisaLanguage($event)"
      (onRowUpdating)="updateVisaLanguage($event)"
      (onRowRemoved)="deleteVisaLanguage($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Dil Adı">
        <dxi-validation-rule
          type="required"
          message="Dil adı zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="description" caption="Açıklama">
        <dxi-validation-rule
          type="required"
          message="Açıklama zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <!-- Visa Country ID için Lookup -->
      <dxi-column dataField="visaCountryId" caption="Ülke">
        <dxo-lookup
          [dataSource]="countries"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="Ülke seçimi zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>


<div class="row">
  <!-- Visa Statuses Grid -->

  
</div>
